// config
export default {
  /**
   * 系统域名列表
   * @type {Array}
   */
  currentUser: window.WEB_CONFIG.currentUser,

  /**
   * 系统域名列表
   * @type {Array}
   */
  domain: window.WEB_CONFIG.domain,

  /**
   * 系统url列表
   * @type {Array}
   */
  urls: window.WEB_CONFIG.urls
}



// WEBPACK FOOTER //
// ./src/config/index.js